import { render, staticRenderFns } from "./XFormRadioGroup.vue?vue&type=template&id=a4604e52&"
import script from "./XFormRadioGroup.vue?vue&type=script&lang=js&"
export * from "./XFormRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports